import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { IconButton, Stack } from '@openedx/paragon';
import { MenuOpen as MenuOpenIcon } from '@openedx/paragon/icons';

import { useCourseOutlineSidebar } from '@src/courseware/course/sidebar/sidebars/course-outline/hooks';
import messages from '@src/courseware/course/sidebar/sidebars/course-outline/messages';

import CourseBreadcrumbs from './CourseBreadcrumbs';

const CourseOutlineTrigger = ({
  courseId,
  sectionId,
  sequenceId,
  unitId,
  isStaff,
  Link,
}) => {
  const intl = useIntl();
  const {
    shouldDisplayFullScreen,
    handleToggleCollapse,
    isActiveEntranceExam,
    isEnabledSidebar,
    isOpen,
    setIsOpen,
  } = useCourseOutlineSidebar();

  const handleCollapse = () => {
    handleToggleCollapse();
    setIsOpen(!isOpen);
  };

  const portalRef = useRef(null);

  useEffect(() => {
    const referenceNode = document.getElementsByClassName('sequence-container')[0];
    const portalNode = document.createElement('div');
    portalNode.className = 'd-flex';
    referenceNode.parentNode.insertBefore(portalNode, referenceNode.parentNode.firstChild);
    portalRef.current = portalNode;
  }, []);

  if (shouldDisplayFullScreen || !isEnabledSidebar || isActiveEntranceExam) {
    return null;
  }

  return (
    portalRef.current && createPortal(
      <Stack direction="horizontal" className={`mb-2.5 ${!isOpen && 'collapsed'}`} gap={4}>
        <IconButton
          alt={intl.formatMessage(messages.toggleCourseOutlineTrigger)}
          className="outline-sidebar-toggle-btn icon-hover"
          iconAs={MenuOpenIcon}
          onClick={handleCollapse}
        />
        <CourseBreadcrumbs
          courseId={courseId}
          sectionId={sectionId}
          sequenceId={sequenceId}
          isStaff={isStaff}
          unitId={unitId}
          Link={Link}
        />
      </Stack>,
      portalRef.current,
    )
  );
};

CourseOutlineTrigger.propTypes = {
  courseId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  sequenceId: PropTypes.string.isRequired,
  unitId: PropTypes.string.isRequired,
  isStaff: PropTypes.bool.isRequired,
  Link: PropTypes.node.isRequired,
};

export default CourseOutlineTrigger;
